import { Injectable } from "@angular/core";
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { catchError, from, Observable, tap } from 'rxjs';
import { HttpService } from "./http.service";
import { OfflineModeService } from "./offline-mode.service";

@Injectable({ providedIn: 'root' })
export class CachedHttpService {
  constructor(
    private http: HttpService,
    private offlineModeService: OfflineModeService
  ) { }

  get<T>(url: string, params = new HttpParams(), noHeaders = false, withCredentials = false, additionalHeaders = new HttpHeaders(), useCache = true): Observable<T> {
    const key = `${url}?${params?.toString() || ''}`;

    if (useCache && !navigator.onLine) {
      return from(this.offlineModeService.getRequest(key)) as Observable<T>;
    }

    return this.http.get<T>(url, params, noHeaders, withCredentials, additionalHeaders).pipe(
      tap(async (res) => {
        if (useCache) await this.offlineModeService.storeRequest(key, res);
      }),
      catchError(() => from(this.offlineModeService.getRequest(key)))
    ) as Observable<T>;
  }
}
